import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import omit from "lodash/omit";
import { Button } from "../DesignSystem/Button/Button";

function FullWidthCard({
  className,
  children,
  visible = true,
  semiVisible,
  onClose,
  hasAction = false,
  actionButtonLabel = "Action button",
  onAction = (x) => x,
  onClickCard = (x) => x,
  ...attributes
}) {
  return (
    <div
      {...omit(attributes, ["event"])}
      className={classnames(
        "FullWidthCard",
        { isClosed: !visible, isOpen: visible, semiVisible },
        className,
      )}
    >
      <div className="FullWidthCard-buttonsOuter">
        {hasAction && (
          <Button
            colorVariant="white"
            className={classnames("FullWidthCard-actionButton", {
              actionButtonUp: !visible,
            })}
            onClick={onAction}
          >
            {actionButtonLabel}
          </Button>
        )}
        <button
          className="FullWidthCard-closeButton"
          type="button"
          onClick={(e) => onClose(e)}
        >
          <img src="/public/images/FullWidthCard/close-icon-brand-gradient.svg" />
        </button>
      </div>
      <div className="FullWidthCard-cardOuter" onClick={(e) => onClickCard(e)}>
        {children}
      </div>
    </div>
  );
}

FullWidthCard.propTypes = {
  className: PropTypes.string,
  actionButtonLabel: PropTypes.string,
  children: PropTypes.any,
  visible: PropTypes.bool,
  hasAction: PropTypes.bool,
  semiVisible: PropTypes.bool,
  onClose: PropTypes.func,
  onAction: PropTypes.func,
  onClickCard: PropTypes.func,
};

export default FullWidthCard;
